function validate_length_max_30(input) {
  return input.length > 30
}

export default validate_length_max_30
